import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { apiUrl } from 'src/core/utils/api';

export const useBulkUpdatePayableRulesStateMutation = () => {
  const companyId = useCompanyId();
  return useMutation(
    ['bookkeeping', 'automation', 'payable-rules', 'update-state'],
    async ({
      payableRuleIds,
      verb,
    }: {
      payableRuleIds: string[];
      verb: 'publish' | 'unpublish';
    }): Promise<
      | { outcome: 'success' }
      | { outcome: 'failure'; reason: 'invalidStateTransition'; ruleId: string }
      | { outcome: 'failure'; reason: 'mcrLimitReached' }
    > => {
      const response = await fetch(
        apiUrl(`/bookkeeping/automation/payable-rules/${verb}`, companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ids: payableRuleIds,
          }),
          credentials: 'include',
        },
      );

      if (!response.ok) {
        const body = await response.json();
        if (body?.error?.reason === 'invalidStateTransition') {
          return {
            outcome: 'failure',
            reason: 'invalidStateTransition',
            ruleId: body.error.ruleId,
          };
        }

        if (body?.reason === 'mcrLimitReached') {
          return {
            outcome: 'failure',
            reason: 'mcrLimitReached',
          };
        }

        throw new Error(`Failed to ${verb} payable rules`);
      }

      return { outcome: 'success' };
    },
    {
      retry: false,
    },
  );
};
